import { Dispatch } from 'redux'

export const CLEAR_ACCOUNT_DETAILS = 'CLEAR_ACCOUNT_DETAILS'

export const clearAccountDetails = (dispatch: Dispatch) =>
  dispatch({ type: CLEAR_ACCOUNT_DETAILS })
